export class UserUpdateDto {
    RoleID: number;
    ReceiveSupportEmails: boolean;
}
